import React from 'react';
import { LeadForm } from '../../components/LeadForm';
export function FarmingtonHeroForm() {
  return <div className="bg-paper p-8 rounded-2xl shadow-2xl border border-subtle-gray relative" data-id="element-1284">
      <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-storm-red text-white px-6 py-2 rounded-full font-bold uppercase tracking-wide whitespace-nowrap shadow-lg" data-id="element-1285">
        Find Your Class or Program
      </div>
      <div className="mt-4" data-id="element-1286">
        <LeadForm buttonText="Check Availability" data-id="element-1287" />
      </div>
    </div>;
}